import { createSlice } from "@reduxjs/toolkit";
import { fetchIndicatorsList, uploadFile } from "./indicatorsApi";
import { TransformIndicatorData } from "./indicators/components/TransformIndicatorData";

interface UsersState {
    indicatorsData: Array<any>;
    isLoading: boolean;
    error: string | null;
    uploadFile: any;
}

const initialState: UsersState = {
    indicatorsData: [],
    isLoading: false,
    error: null,
    uploadFile: {},
};

const indicatorsSlice = createSlice({
    name: "indicatorsData",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchIndicatorsList actions
            .addCase(fetchIndicatorsList.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchIndicatorsList.fulfilled, (state, action) => {
                state.isLoading = false;
                const agr: any = action.meta.arg;
                const indicatorId: number = parseInt(agr.id);
                const fromYearVal: number = agr.startYear;
                const endYearVal: number = agr.endYear;

                try {
                    state.indicatorsData = TransformIndicatorData(
                        indicatorId,
                        action?.payload?.data || [],
                        action?.payload?.metadata || [],
                        fromYearVal,
                        endYearVal
                    );
                } catch (error) {
                    state.error = "Failed to process indicator data.";
                }
            })
            .addCase(fetchIndicatorsList.rejected, (state, action) => {
                state.isLoading = false;
                const errorMessage = 
                    typeof action.payload === "string"
                        ? action.payload
                        : action.error?.message || "Failed to fetch indicators.";
                state.error = errorMessage;
            })
            
            // Handle uploadFile actions
            .addCase(uploadFile.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(uploadFile.fulfilled, (state, action) => {
                state.isLoading = false;
                state.uploadFile = action?.payload?.data || [];
            })
            .addCase(uploadFile.rejected, (state, action) => {
                state.isLoading = false;
                const errorMessage = 
                typeof action.payload === "string"
                    ? action.payload
                    : action.error?.message || "File upload failed.";
                state.error = errorMessage;
            });
    },
});

export default indicatorsSlice.reducer;
